import { useDevice } from "../hooks";

interface Props {
  mobile?: boolean;
  visible?: boolean;
  children?: any;
}

const Visible = ({ visible = true, mobile, children }: Props) => {
  const { isMobile } = useDevice();
  return (mobile === undefined ? visible : isMobile === mobile) && children;
};

export default Visible;
